const MODAL_STYLES = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        backgroundColor: '#fff',
        borderRadius: '14px',
        height: 'max-content'
    },
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: '#00000090',
        backdropFilter: 'blur(10px)',
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        paddingRight: '5%',
        paddingLeft: '5%',
        display: 'flex',
        alignItems: 'center', 
        justifyContent: 'center',
    }
}

export default MODAL_STYLES